import type { SVGProps } from 'react'
const SvgSyShow = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g fillRule="evenodd" strokeLinejoin="round" clipRule="evenodd">
			<path
				d="M12 8.14a3.924 3.924 0 0 0-3.912 3.913A3.924 3.924 0 0 0 12 15.965a3.924 3.924 0 0 0 3.912-3.912A3.924 3.924 0 0 0 12 8.14m0 1.5a2.4 2.4 0 0 1 2.412 2.413c0 1.34-1.071 2.412-2.412 2.412s-2.412-1.071-2.412-2.412A2.4 2.4 0 0 1 12 9.64"
				opacity={0.4}
			/>
			<path d="M11.998 4.002c-4.166.002-7.893 2.997-9.937 7.756a.75.75 0 0 0 0 .592c2.044 4.758 5.771 7.754 9.937 7.755h.004l.002-.002c4.165-.003 7.891-2.996 9.935-7.753a.75.75 0 0 0 0-.592c-2.044-4.759-5.771-7.754-9.937-7.756zm0 1.5h.004c3.36.002 6.495 2.39 8.39 6.55-1.894 4.163-5.03 6.552-8.39 6.553h-.004c-3.36-.001-6.496-2.39-8.39-6.552 1.895-4.161 5.03-6.55 8.39-6.551" />
		</g>
	</svg>
)
export default SvgSyShow
